$(function(){
  
  var $template = $(".template").val();
  var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  /* login form */
  $(".form-row .btn-login").on("click",function(){
    var $form = $(this).parents('form');
    var txtmail = $(".txtmail").val();
    var txtpass = $(".txtpwd").val();    

    if(txtmail == '' ){    
      $form.find(".error-msg").text("Email Can't be blank");
      $form.find(".txtmail").focus();
      return false;
    }
    else if(!regexEmail.test(txtmail)){    
      $form.find(".error-msg").text("Invalid email");
      $form.find(".txtmail").focus();
      return true;
    } 
    if(txtpass == ''){    
      $form.find(".error-msg").text("Password Can't be blank");
      $form.find(".txtpwd").focus();
      return false;
    } 
    else{
      $form.find(".error-msg").text(" ");
      $(".login").submit();
      return true;
    }
  });

  /* recover password*/
  $(".btn-recover").on("click",function(){
    var $form = $(this).parents('form');
    var txtmail = $(".txtemail").val();

    if(txtmail == '' ){    
      $form.find(".error-msg").text("Email Can't be blank");
      $form.find(".txtemail").focus();
      return false;
    }
    else if(!regexEmail.test(txtmail)){    
      $form.find(".error-msg").text("Invalid email");
      $form.find(".txtemail").focus();
      return false;
    }
    else{
      $form.find(".error-msg").text(" ");
      $(".lost_reset_password").submit();
      return true;
    }
  });

  /* register form */
  $(".btn-register").on("click",function(){
    var $form = $(this).parents('form');
    var fname = $(".fname").val();
    var lname = $(".lname").val();
    var emailid = $(".emailid").val();
    var userpassword = $(".userpassword").val();
    if(fname == '' ){    
      $form.find(".error-msg").text("Firstname Can't be blank");
      $form.find(".fname").focus();
      return false;
    }
    else if(lname == '' ){    
      $form.find(".error-msg").text("Lastname Can't be blank");
      $form.find(".lname").focus();
      return false;
    }
    else if(emailid == '' ){    
      $form.find(".error-msg").text("Email Can't be blank");
      $form.find(".emailid").focus();
      return false;
    }
    else if(!regexEmail.test(emailid)){    
      $form.find(".error-msg").text("Invalid email");
      $form.find(".emailid").focus();
      return true;
    } 
    else if(userpassword == ''){    
      $form.find(".error-msg").text("Password Can't be blank");
      $form.find(".userpassword").focus();
      return false;
    } 
    else{
      $form.find(".error-msg").text(" ");
      $(".register").submit();
      return true;
    }
  });

  /* address page */
  //   $(".btn-address").click(function(){
  //     var $form = $(this).parents('form');
  //     var userfname = $(".fname").val();
  //     var lname = $(".lname").val();
  //     var txtcompany = $(".txtcompany").val();
  //     var txtadd = $(".txtadd").val();
  //     var txtadd1 = $(".txtadd1").val();
  //     var txtcity = $(".txtcity").val();
  //     var country = $(".country").val();
  //     var txtzip = $(".txtzip").val();
  //     var txtphone = $(".txtphone").val();
  //     var err_msg = "This Field can't be blank"

  //     if(userfname == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".fname").focus();
  //       return false;
  //     }
  //     else if(lname == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".lname").focus();
  //       return false;
  //     }
  //     else if(txtcompany == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtcompany").focus();
  //       return false;
  //     }
  //     else if(txtadd == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtadd").focus();
  //       return false;
  //     }
  //     else if(txtadd1 == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtadd1").focus();
  //       return false;
  //     }
  //     else if(txtcity == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtcity").focus();
  //       return false;
  //     }
  //     else if(country == '---'){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".country").focus();
  //       return false;
  //     }
  //     else if(txtzip == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtzip").focus();
  //       return false;
  //     }
  //     else if(isNaN(txtzip)){    
  //       $form.find(".error-msg").text("Allow only numeric value");
  //       $form.find(".txtzip").focus();
  //       return false;
  //     }
  //     else if(txtphone == '' ){    
  //       $form.find(".error-msg").text(err_msg);
  //       $form.find(".txtphone").focus();
  //       return false;
  //     }
  //     else if(isNaN(txtphone)){    
  //       $form.find(".error-msg").text("Allow only numeric value");
  //       $form.find(".txtphone").focus();
  //       return false;
  //     }
  //     else {    
  //       $form.find(".error-msg").text('');
  //       $(".Address").submit();
  //       return false;
  //     }
  //   });

  /* reset password */
  $(".btn-reset").click(function(){
    var $form = $(this).parents('form');
    var userpwd = $(".userpwd").val();
    var txtcpwd = $(".txtcpwd").val();

    if(userpwd == '' ){    
      $form.find(".error-msg").text("Password Can't be blank");
      $form.find(".userpwd").focus();
      return false;
    }
    else if(txtcpwd != txtpwd ){    
      $form.find(".error-msg").text("Password doesn't match");
      $form.find(".txtcpwd").focus();
      return false;
    }
    else{
      $form.find(".error-msg").text(" ");
      $(".lost_reset_password").submit();
      return true;
    }
  }); 

  /* active account */
  $(".btn-active").click(function(){
    var $form = $(this).parents('form');
    var userpwd = $(".userpwd").val();
    var txtcpwd = $(".usercpwd").val();

    if(userpwd == '' ){    
      $form.find(".error-msg").text("Password Can't be blank");
      $form.find(".userpwd").focus();
      return false;
    }
    else if(txtcpwd != userpwd ){    
      $form.find(".error-msg").text("Password doesn't match");
      $form.find(".usercpwd").focus();
      return false;
    }
    else{
      $form.find(".error-msg").text(" ");
      $(".lost_reset_password").submit();
      return true;
    }
  });

});

$(document).on('click','.c-close', function(){ 

  var data_id = $(this).attr("data-id");
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: "quantity=0&id=" + data_id,
    success: function(data){
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(cartdata){
          var cart_drawer = $(cartdata).find('.js-cart-form').html();
          $('.js-cart-form').html(cart_drawer);
          var cartCount =  $(cartdata).find('.minicart-cont').text();
          $('.minicart-cont').text(cartCount);
          if(cartCount == 0 ){
            $('.header-cart-empty').removeClass('hidden');
            $('.js-cart-form').addClass('hidden');
          }
        }
      });
    }
  });
});
function addtocart(obj){

  var form = $(obj).parents('form');
  var cart_items_html = "";   
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),
    dataType: 'json',
    success: function(response){  
      $.ajax({
        type:"GET",
        url:"/cart.js",
        dataType: 'json',
        success: function(cart){ 
          var data_currency = $(".site-content").attr('data-currency');
          var money_format = "{{shop.money_format}}";
          var cart_count = $('.minicart-cont').text(cart.item_count);          
          if (cart.item_count == 0) {
            $('.header-cart-empty').removeClass('hidden');
            $('.js-cart-form').addClass('hidden');

$.getJSON('/cart.js',function(cart){

if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
         typeof BOLD.common.eventEmitter.emit === 'function' && BOLDCURRENCY.currentCurrency ){
cart = window.BOLD.common.cartDoctor.fix(cart);
       BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
console.log('ran')
     }

})

          } 
          else {
            $('.header-cart-empty').addClass('hidden');
            $('.js-cart-form').removeClass('hidden');
            $.each(cart.items, function(index, item) {            
              var index = index + 1;
              $('.header-cart-empty').addClass('hidden');
              $('.mini-cart-view').removeClass('hidden');

              if(item.image == null){
                var imgsection = '<img src="//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif">';
              }
              else{
                var imgsection = '<img src="'+ item.image +'">';
              }
              if(item.variant_title == null ){
                var variant_vall = '';
              }else{
                var variant_vall = item.variant_title
                }
              cart_items_html += '<div class="m-item">'; 
              cart_items_html += '<a class="c-close" data-id="'+ item.variant_id +'" data-line="'+ index +'"> x <a>';
              cart_items_html += '<div class="m-c-img">';
              cart_items_html += '<a href="'+ item.url +'">'
              cart_items_html += imgsection;
              cart_items_html += '</a>'
              cart_items_html += '</div>'; 
              cart_items_html += '<div class="m-c-detail">';
              cart_items_html += '<div class="un-product-details">';
              cart_items_html += '<p class="product-single__vendor">'
              cart_items_html += '<a class="product-single__vendor">'+ item.product_title +'</a>';
              cart_items_html += '</p>';
              cart_items_html += '<h5>'
              cart_items_html += '<a href="'+ item.url +'">'+ variant_vall +'</a>'
              cart_items_html += '</h5>';
              cart_items_html += '<div class="price-wrapper">';  
              cart_items_html += '<span class="woocs_price_code" data-product-id="'+ item.id +'">';  
              cart_items_html += '<span class="price-new money">'+ Shopify.formatMoney(item.price, $(".site-content").attr('data-currency'))  +'</span>';  			
              cart_items_html += '</span>';
              cart_items_html += '</div>';
              cart_items_html += '</div>';
              cart_items_html += '</div>';
              cart_items_html += '</div>';  
            });

            var cartCount =  $(cart).find('.minicart-cont').text();
            $('.mini-cart-items').html(cart_items_html); 
            $('.mini-cart-view').show();
            setTimeout(function(){ $('.mini-cart-view').hide()},5000); 
            $('.total-amt span:nth-child(2)').text(Shopify.formatMoney(cart.total_price,$(".money_format").val()));  




$.getJSON('/cart.js',function(cart){

if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
         typeof BOLD.common.eventEmitter.emit === 'function' && BOLDCURRENCY.currentCurrency ){
cart = window.BOLD.common.cartDoctor.fix(cart);
       BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
console.log('ran')
     }

})



      
          }
        },                    
        complete: function() {
          $('.mini-cart-view').fadeIn();
          timeOut = setTimeout(function(){ $('.mini-cart-view').fadeOut()}, 3000);

        },
        error: function (jqXHR, textStatus, errorThrown) {
          if(jqXHR.status == 422) {               
            $(".error_msg").text(jqXHR.responseJSON.description);                 
          }
        } 
      });
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 422) {
        $('.mini-cart-view').fadeIn();
        timeOut = setTimeout(function(){ $('.mini-cart-view').fadeOut()},3000);
        $('.error_msg').html(jqXHR.responseJSON.description).show();
        setTimeout(function(){ $('.error_msg').hide();},3000);  
      }
    }
  }); 
}
$(".checkout-btn").on("click",function(){
  $(".btn_checkout").trigger("click");
});
function addtocheck(obj){

  var form = $(obj).parents('form');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),

    dataType: 'json',
    success: function(response){
      
      //bold update pricing
$.getJSON('/cart.js',function(cart){

if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
         typeof BOLD.common.eventEmitter.emit === 'function' && BOLDCURRENCY.currentCurrency ){
cart = window.BOLD.common.cartDoctor.fix(cart);
       BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
console.log('ran2')
     }

})

  
      $.ajax({
        type:"GET",
        url:"/cart.js",
        dataType: 'json',
        success: function(cart){ 
          console.log('success');
          location.href="/checkout"
        },         

      }); 
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 422) {
        console.log(jqXHR.responseJSON.description);  
      }
    }
  })

}
$(function(){
  $('.cpn-btn').click(function(){
    var distext = $(this).parent(".coupon-i-wrap").find(".input-cpn").val();
    console.log(distext);
    if(distext == ''){
      var errmsg = $(this).parent(".coupon-i-wrap").find(".cpn-error");
      errmsg.text("This field can't be blank");
      setTimeout(function(){ $(errmsg).hide(); }, 2000);

    }
    var dataurl = $(this).attr("data-url");  
  });
});


// $(document).ready(function(){
//   $('.search-i-ic').on('click', function(){
//     $('.search-i-bx').toggleClass('opened');
//     $('.user-i-form').removeClass('opened');
//   });

//   $('.user-i-ic').on('click', function(){
//     $('.user-i-form').toggleClass('opened');
//     $('.search-i-bx').removeClass('opened');
//   });
// });

var locate = window.location.href;
locate = locate.split('/account#').pop();

$(document).ready(function(){  
  
  $(document).find('.head-acc-info').click(function(){
    var hrf = $(this).find('a').attr('href');
    hrf = hrf.split('/account#').pop();
    $(document).find($('.ac-nav-link[ac-tab-id="'+hrf+'"]').trigger('click'));
  });
  
  setTimeout(function(){
    $(document).find($('.ac-nav-link[ac-tab-id="'+locate+'"]')).trigger('click');
  },100);
    
  $('.ac-nav-link').on('click', function(){
    $(this).parent('li').addClass('is-active').siblings('li').removeClass('is-active');
    $('#'+$(this).attr('ac-tab-id')).removeClass('ac-hide').siblings('.ac-tab-content').addClass('ac-hide');
  });

  $('.order-i-btn').on('click', function(){
    if($(this).hasClass('active')) {
      $(this).removeClass('active').text('view order');
      $('.'+$(this).attr('order-id')).hide();
    } else {
      $(this).addClass('active').text('close order');
      $('.'+$(this).attr('order-id')).show();
    }
  });
  var cookie_val = $.cookie("subscription");
  if(cookie_val){
    $("#subscription").prop('checked', true);  
  }else{
    $("#subscription").prop('checked', false);  
  }
  $("#subscription").click(function(){
    var value = $(this).val();
    if($(this).prop("checked") == true){
      $.cookie("subscription", value, { expires : 365 });
    }
    else if($(this).prop("checked") == false){
      $.cookie("subscription", null);
    }
  });
});


